import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
export const NotificationsDrawerContext = /*#__PURE__*/ createContext(null);
export const useNotificationsDrawerContext = ()=>{
    const context = useContext(NotificationsDrawerContext);
    if (!context) {
        throw new Error('No data available');
    }
    return context;
};
export const NotificationsDrawerContextProvider = ({ children })=>{
    const [visibility, setVisibility] = useState(false);
    return /*#__PURE__*/ _jsx(NotificationsDrawerContext.Provider, {
        value: {
            visibility,
            setVisibility
        },
        children: children
    });
};
